import React, { useState, useRef } from "react";
import { Box, Pressable, useMediaQuery } from "native-base";
import { deleteIconSVG } from "../../utils/svg";
import { hasPermission } from "../../utils/permission";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COLORS } from "../../utils/colors";
import Svg from "react-native-svg";

const VideoViewer = ({
  url = "",
  ind,
  onDeleteVideo,
  width = "165px",
  height = "167px",
  svg = deleteIconSVG,
  svgwh = "24",
  p = "1",
  permission = true,
  type = "detail",
  scrollToTop = () => {},
  resizeMode = false,
  onVideoClick = null
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = async (e) => {
    e.stopPropagation(); // Prevent event bubbling
    if (videoRef.current) {
      try {
        if (isPlaying) {
          videoRef.current.pause();
          setIsPlaying(false);
        } else {
          await videoRef.current.play();
          setIsPlaying(true);
        }
      } catch (error) {
        console.error('Error playing video:', error);
        // If autoplay fails, try unmuting and playing again
        if (videoRef.current.muted) {
          videoRef.current.muted = false;
          try {
            await videoRef.current.play();
            setIsPlaying(true);
          } catch (secondError) {
            console.error('Error playing video after unmuting:', secondError);
          }
        }
      }
    }
  };

  const handleVideoClick = () => {
    if (onVideoClick) {
      onVideoClick(url);
    }
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  return (
    <Box
      mb={3.5}
      mr={3.5}
      position="relative"
      width={width}
      height={height}
      style={{
        background: "#f0f0f0",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100px",
        minWidth: "100px",
        position: width === "100%" && height === "100%" ? "absolute" : "relative",
        top: width === "100%" && height === "100%" ? 0 : undefined,
        left: width === "100%" && height === "100%" ? 0 : undefined,
      }}
    >
      <Pressable onPress={handleVideoClick} style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <video
          ref={videoRef}
          src={url}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            cursor: "pointer",
            display: "block",
            maxWidth: "100%",
            maxHeight: "100%",
          }}
          onEnded={handleVideoEnded}
          onPlay={handleVideoPlay}
          onPause={handleVideoPause}
          muted={false}
          controls={false}
          preload="metadata"
        />
      </Pressable>
      
      {/* Play/Pause Overlay */}
      <Pressable
        onPress={handlePlayPause}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        zIndex={10}
        p={2}
        bg="rgba(0, 0, 0, 0.5)"
        borderRadius="full"
        style={{ cursor: 'pointer' }}
        onPressIn={(e) => e.stopPropagation()}
      >
        <Svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          {isPlaying ? (
            // Pause icon
            <path d="M6 4h4v24H6V4zm12 0h4v24h-4V4z"/>
          ) : (
            // Play icon
            <path d="M8 5v22l18-11z"/>
          )}
        </Svg>
      </Pressable>

      {/* Delete Button */}
      {((hasPermission("REVIEW") && type === "detail") ||
        (!hasPermission("REVIEW") && permission)) && (
        <Pressable
          onPress={() => {
            onDeleteVideo(ind);
          }}
          zIndex="99"
          position="absolute"
          top={1}
          right={1}
          p={p}
          style={{
            width: "50px",
            height: "50px",
            marginTop: MobileWindow ? "3px" : 0,
            backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
          }}
        >
          <Svg width={svgwh} height={svgwh} viewBox={`0 0 ${svgwh} ${svgwh}`}>
            {svg}
          </Svg>
        </Pressable>
      )}
    </Box>
  );
};

export default VideoViewer; 